<div class='content measure-module'>
  <p>Výběr parcel geometrií v mapě.</p>
  <gmt-switch [options]="intersectionOptions" [(selectedId)]="intersectionOptionsSelections" (select)="onChangedIntersectionType($event.id)">
  </gmt-switch>
</div>
